import React from "react";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Rating from "@mui/material/Rating";

function RecipeRating({ rating }) {
  return (
    <>
      <Stack direction="row" spacing={0.5} mt={1}>
        <Rating name="rating-recipe" value={rating || 0} readOnly precision={0.1} size="small" />
        <Typography variant="body2" color="text.secondary">
          {rating}
        </Typography>
      </Stack>
    </>
  );
}

export default RecipeRating;